import { InputText } from 'primereact/inputtext'
import React from 'react'

interface IProps {
  placeholder: string
  value: string | undefined
  setValue: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
}

export const SearchBar = ({ value, setValue, placeholder, className }: IProps) => {
  return (
    <div>
      <span className="p-input-icon-left w-full">
        <i className="pi pi-search" />
        <InputText placeholder={placeholder} value={value} onChange={setValue} className={className} />
      </span>
    </div>
  )
}
